import React from "react";
import { Space } from "antd";
import { AxPopover, AxButton, AxDivider } from "@dynata/axiom3";

class PopOver extends React.Component {
  render() {
    return (
      <div className="section" id="popover">
        <h3>Popover</h3>
        <p>The floating card popped by clicking or hovering.</p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space direction="vertical">
          <Space size="large" direction="vertical">
            <pre>{`<AxPopover
  content={
    "Conveniently initiate viral synergy without multi functional platforms."
  }
  title="Title"
>
  <span>Hover me</span>
</AxPopover>`}</pre>
            <div className="prop-header">
              <p className="props-title">Props</p>
              <p>
                For AntD props, visit{" "}
                <AxButton
                  size="small"
                  type="link"
                  target="_blank"
                  href="https://ant.design/components/popover/#API"
                >
                  https://ant.design/components/popover/#API
                </AxButton>
              </p>
            </div>
            <table className="props-table">
              <thead>
                <tr>
                  <th>Param</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default value</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>content</td>
                  <td>Content of the card</td>
                  <td>ReactNode | () =&gt; ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>title</td>
                  <td>Title of the card</td>
                  <td>ReactNode | () =&gt; ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>...others</td>
                  <td>
                    All extra props are passed down to the{" "}
                    <>
                      <AxButton
                        size="small"
                        type="link"
                        target="_blank"
                        href="https://4x.ant.design/components/popover/#API"
                      >
                        {`<Popover />`}
                      </AxButton>
                    </>{" "}
                    component.
                  </td>
                  <td></td>
                  <td>-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <pre>{`<AxPopover
  content={
    "Conveniently initiate viral synergy without multi functional platforms."
  }
  title="Title"
>
  <span>Hover me</span>
</AxPopover>`}</pre>
          </Space>
        </Space>

        <AxDivider orientation="left" plain>
          Default
        </AxDivider>

        <Space direction="vertical" size={40}>
          <AxPopover
            content={
              "Conveniently initiate viral synergy without multi functional platforms."
            }
            title="Title"
          >
            <AxButton size="large" type="link">
              Hover me
            </AxButton>
          </AxPopover>
        </Space>
      </div>
    );
  }
}
export default PopOver;
